<template>
    <div>

        <div class="grid grid-cols-12 gap-6" v-if="time_selection_mode === 'free'">

            <div class="col-span-6">
                <select-menu :values="index.slice(0, -1)"
                             :text="timeValues.slice(0, -1)"
                             v-model.number="startIndex">
                    Von
                </select-menu>
            </div>

            <div class="col-span-6">
                <select-menu :values="index.slice(1)"
                             :text="timeValues.slice(1)"
                             v-model.number="endIndex">
                    Bis
                </select-menu>
            </div>

        </div>

        <div v-if="time_selection_mode === 'slot'">
            <slot-select :has-header="false" v-model="slot"></slot-select>
        </div>
    </div>
</template>

<script>
import SlotSelect from "./SlotSelect.vue";
import SelectMenu from "./UI/SelectMenu";
import get from "lodash/get";

export default {
    name: "TimeSelect",

    components: {
        SlotSelect,
        SelectMenu,
    },

    inject: ['group'],

    props: {
        value: {},
        time_selection_mode: {
            type: String,
            default: 'free', // free or slot
        },
        startTime: {
            default: 6, // start of booking time
        },
        endTime: {
            default: 22, // end of booking time
        },
        hasHalfSteps: {
            default: true,
        },
    },

    data: () => ({
        startIndex: 0,
        endIndex: 1,
    }),

    created() {
        this.updateTime();
        this.boot();
    },

    watch: {
        time_selection_mode() {
            this.updateTime();
            this.boot();
        },
        startIndex(value) {
            if (this.endIndex <= value) {
                this.endIndex = value + 1;
            }
            this.$emit('input', this.time);
        },
        endIndex(value) {
            if (this.startIndex >= value) {
                this.startIndex = value - 1;
            }
            this.$emit('input', this.time);
        },
    },

    computed: {
        slots() {
            return get(this.group, 'slots', [
                {begin: 6, end: 18},
            ]);
        },
        slot: {
            get() {
                // strip the minute values
                const [start, end] = this.value.split('-');
                return `${start.split(':')[0]}-${end.split(':')[0]}`;
            },
            set(value) {
                // add minute values!
                const [start, end] = value.split('-');
                this.$emit('input', `${start}:00-${end}:00`);
            },
        },
        time() {
            return this.timeValues[this.startIndex] + '-' + this.timeValues[this.endIndex];
        },
        timeValues() {
            if (this.hasHalfSteps) {
                // TODO hard coded 30 minute slices.... break it up?
                const length = (this.endTime - this.startTime) * 2 + 1;
                return Array.from({length}, (_, i) => i).map(i => {
                    return (Math.floor(i / 2) + this.startTime).toString() + ':' + (i % 2 ? '30' : '00');
                });
            }

            if (!this.hasHalfSteps) {
                const length = (this.endTime - this.startTime) + 1;
                return Array.from({length}, (_, i) => i).map(i => {
                    return (i + this.startTime).toString() + ':00';
                });
            }

            const length = (this.endTime - this.startTime) + 1;
            return Array.from({length}, (_, i) => i).map(i => {
                return (i + this.startTime).toString();
            });
        },
        index() {
            return [...this.timeValues.keys()];
        },
    },

    methods: {
        updateTime() {
            if (this.time_selection_mode === 'free') {
                this.$emit('input', this.time);
                return;
            }

            this.$emit('input', `${this.slots[0].begin}:00-${this.slots[0].end}:00`);
        },
        boot() {
            if (this.time_selection_mode === 'free') {
                const [start, end] = this.value.split('-');
                let endIdx = this.timeValues.findIndex(t => t === end);
                const startIdx = this.timeValues.findIndex(t => t === start);

                if (startIdx !== -1) {
                    this.startIndex = startIdx;
                }

                if (endIdx === -1) {
                    endIdx = this.timeValues.findIndex(t => t === '06:00');
                }

                if (endIdx !== -1) {
                    this.endIndex = endIdx;
                }
            }
        }
    },
}
</script>

<style scoped>

</style>
